import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Divider, Grid } from '@mui/material'

import Button from '../components/Button'
import Dialog from '../components/Dialog'
import GridHeader from '../components/GridHeader'
import DialogZone from '../components/DialogZone'
import DialogCorsi from '../components/DialogCorsi'
import DialogFeatures from '../components/DialogFeatures'
import DialogCategorie from '../components/DialogCategorie'
import DialogDomeniche from '../components/DialogDomeniche'
import DialogTabellone from '../components/DialogTabellone'
import DialogTabelloni from '../components/DialogTabelloni'
import DialogCampionati from '../components/DialogCampionati'
import DialogAccoppiamenti from '../components/DialogAccoppiamenti'
import DialogImpostazioniMail from '../components/DialogImpostazioniMail'
import DialogImpostazioniAvanzate from '../components/DialogImpostazioniAvanzate'
import DialogImpostazioniContatti from '../components/DialogImpostazioniContatti'
import DialogImpostazioniAlgoritmi from '../components/DialogImpostazioniAlgoritmi'
import {
  useGetBackendFeaturesQuery,
  useUpdateImpostazioniMutation,
} from '../hooks/api-slice'
import { config } from '../settings/configs'
import {
  colours,
  titlesImpostazioni as titles,
  phrasesImpostazioni as phrases,
} from '../settings/settings'

const Impostazioni = () => {
  const impostazioniContatti = useSelector(
    state => state.home.impostazioniContatti,
  )
  const impostazioniMail = useSelector(state => state.home.impostazioniMail)
  const impostazioniAlgoritmi = useSelector(
    state => state.home.impostazioniAlgoritmi,
  )
  const impostazioniAvanzate = useSelector(
    state => state.home.impostazioniAvanzate,
  )
  const { data: backendFeatures } = useGetBackendFeaturesQuery()
  const [updateImpostazioniMutation] = useUpdateImpostazioniMutation()

  document.title = `${config?.name} - Impostazioni`

  const [openSuccess, setOpenSuccess] = useState()
  const [openZone, setOpenZone] = useState()
  const [openDomeniche, setOpenDomeniche] = useState()
  const [openAccoppiamenti, setOpenAccoppiamenti] = useState()
  const [openCampionati, setOpenCampionati] = useState()
  const [openCategorie, setOpenCategorie] = useState()
  const [openTabelloni, setOpenTabelloni] = useState()
  const [openTabellone, setOpenTabellone] = useState()
  const [openFeatures, setOpenFeatures] = useState()
  const [openContatti, setOpenContatti] = useState()
  const [openMail, setOpenMail] = useState()
  const [openAlgoritmi, setOpenAlgoritmi] = useState()
  const [openCorsi, setOpenCorsi] = useState()
  const [openAvanzate, setOpenAvanzate] = useState()

  const handleClickOpenSuccess = () => setOpenSuccess(true)
  const handleClickOpenZone = () => setOpenZone(true)
  const handleClickOpenDomeniche = () => setOpenDomeniche(true)
  const handleClickOpenAccoppiamenti = () => setOpenAccoppiamenti(true)
  const handleClickOpenCampionati = () => setOpenCampionati(true)
  const handleClickOpenCategorie = () => setOpenCategorie(true)
  const handleClickOpenTabelloni = () => setOpenTabelloni(true)
  const handleClickOpenTabellone = () => setOpenTabellone(true)
  const handleClickOpenFeatures = () => setOpenFeatures(true)
  const handleClickOpenContatti = () => setOpenContatti(true)
  const handleClickOpenMail = () => setOpenMail(true)
  const handleClickOpenAlgoritmi = () => setOpenAlgoritmi(true)
  const handleClickOpenCorsi = () => setOpenCorsi(true)
  const handleClickOpenAvanzate = () => setOpenAvanzate(true)

  const handleCloseSuccess = () => setOpenSuccess()
  const handleCloseZone = () => setOpenZone()
  const handleCloseDomeniche = () => setOpenDomeniche()
  const handleCloseAccoppiamenti = () => setOpenAccoppiamenti()
  const handleCloseCampionati = () => setOpenCampionati()
  const handleCloseCategorie = () => setOpenCategorie()
  const handleCloseTabelloni = () => setOpenTabelloni()
  const handleCloseTabellone = () => setOpenTabellone()
  const handleCloseFeatures = () => setOpenFeatures()
  const handleCloseContatti = () => setOpenContatti()
  const handleCloseMail = () => setOpenMail()
  const handleCloseAlgoritmi = () => setOpenAlgoritmi()
  const handleCloseCorsi = () => setOpenCorsi()
  const handleCloseAvanzate = () => setOpenAvanzate()

  const updateImpostazioni = async x => {
    let body, handleClose
    if (x === 'contatti') {
      body = { contatti: impostazioniContatti }
      handleClose = handleCloseContatti
    } else if (x === 'mail') {
      body = { mail: impostazioniMail }
      handleClose = handleCloseMail
    } else if (x === 'algoritmi') {
      body = { algoritmi: impostazioniAlgoritmi }
      handleClose = handleCloseAlgoritmi
    } else if (x === 'avanzate') {
      body = { avanzate: impostazioniAvanzate }
      handleClose = handleCloseAvanzate
    }

    const result = await updateImpostazioniMutation(body)
    if (!result.error) {
      handleClose()
      handleClickOpenSuccess()
    }
  }

  const confirmContatti = async () => await updateImpostazioni('contatti')
  const confirmMail = async () => await updateImpostazioni('mail')
  const confirmAlgoritmi = async () => await updateImpostazioni('algoritmi')
  const confirmAvanzate = async () => await updateImpostazioni('avanzate')

  const GridTransparentButton = ({ onClick, title }) => (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <center>
        <Button transparent borderColor={colours.grey} onClick={onClick}>
          {title}
        </Button>
      </center>
    </Grid>
  )

  return (
    <Grid container paddingX={2} spacing={2} sx={{ width: '100%' }}>
      <GridHeader h2 text='Impostazioni' />
      <Grid container sx={{ width: '100%' }}>
        <GridTransparentButton
          onClick={handleClickOpenFeatures}
          title={titles.titleFeatures}
        />
        <GridTransparentButton
          onClick={handleClickOpenContatti}
          title={titles.titleContatti}
        />
        {backendFeatures?.mail && (
          <GridTransparentButton
            onClick={handleClickOpenMail}
            title={titles.titleMail}
          />
        )}
        <GridTransparentButton
          onClick={handleClickOpenAvanzate}
          title={titles.titleAvanzate}
        />
        <Divider sx={{ width: '100%' }} />
        <GridTransparentButton
          onClick={handleClickOpenCampionati}
          title={titles.titleCampionati}
        />
        <GridTransparentButton
          onClick={handleClickOpenCategorie}
          title={titles.titleCategorie}
        />
        <GridTransparentButton
          onClick={handleClickOpenZone}
          title={titles.titleZone}
        />
        {config?.features?.algoritmi && (
          <GridTransparentButton
            onClick={handleClickOpenAccoppiamenti}
            title={titles.titleAccoppiamenti}
          />
        )}
        {config?.features?.algoritmi && (
          <GridTransparentButton
            onClick={handleClickOpenDomeniche}
            title={titles.titleDomeniche}
          />
        )}
        {config?.features?.algoritmi && (
          <GridTransparentButton
            onClick={handleClickOpenAlgoritmi}
            title={titles.titleAlgoritmi}
          />
        )}
        <Divider sx={{ width: '100%' }} />
        {config?.features?.tabelloni && (
          <GridTransparentButton
            onClick={handleClickOpenTabelloni}
            title={titles.titleTabelloni}
          />
        )}
        {config?.features?.tabelloni && (
          <GridTransparentButton
            onClick={handleClickOpenTabellone}
            title={titles.titleTabellone}
          />
        )}
        {config?.features?.corsi && (
          <GridTransparentButton
            onClick={handleClickOpenCorsi}
            title={titles.titleCorsi}
          />
        )}
      </Grid>
      <Dialog
        open={openSuccess}
        handleClose={handleCloseSuccess}
        title={titles.titleSuccess}
        textContent={phrases.phraseSuccess}
        textUndo=''
        textConfirm='Ok'
      />
      <DialogZone open={openZone} handleClose={handleCloseZone} />
      <DialogDomeniche
        open={openDomeniche}
        handleClose={handleCloseDomeniche}
      />
      <DialogAccoppiamenti
        open={openAccoppiamenti}
        handleClose={handleCloseAccoppiamenti}
      />
      <DialogCampionati
        open={openCampionati}
        handleClose={handleCloseCampionati}
      />
      <DialogCategorie
        open={openCategorie}
        handleClose={handleCloseCategorie}
      />
      <DialogTabelloni
        open={openTabelloni}
        handleClose={handleCloseTabelloni}
      />
      <DialogTabellone
        open={openTabellone}
        handleClose={handleCloseTabellone}
      />
      <DialogFeatures open={openFeatures} handleClose={handleCloseFeatures} />
      <DialogCorsi open={openCorsi} handleClose={handleCloseCorsi} />
      <DialogImpostazioniContatti
        open={openContatti}
        handleClose={handleCloseContatti}
        triggerFunction={confirmContatti}
      />
      <DialogImpostazioniMail
        open={openMail}
        handleClose={handleCloseMail}
        triggerFunction={confirmMail}
      />
      <DialogImpostazioniAlgoritmi
        open={openAlgoritmi}
        handleClose={handleCloseAlgoritmi}
        triggerFunction={confirmAlgoritmi}
      />
      <DialogImpostazioniAvanzate
        open={openAvanzate}
        handleClose={handleCloseAvanzate}
        triggerFunction={confirmAvanzate}
      />
    </Grid>
  )
}

export default Impostazioni
